/**
 * Whether a browser tab reports to Sentry, and under which environment.
 *
 * Only production reports (owner's decision, 2026-10-13): the monthly quota is
 * shared with dev and ran out in 2026-10, and nobody read dev's events. Since
 * 2026-09-18 dev and prod run the SAME image (CLAUDE.md, "Una imagen, dos
 * entornos"), so nothing decided at build time can tell them apart — the old
 * `environment: import.meta.env.MODE` said "production" in both. The hostname
 * is the only thing that differs, so it is decided at runtime — the browser
 * twin of the backends deriving it from `REGION_CODE`.
 *
 * - `*.dev.bolloprint.com` / `dev.bolloprint.com` → `null` (dev: no Sentry)
 * - any other `bolloprint.com` host → `production` (the label alert rules key
 *   on; the region rides in the hostname, not in the environment name)
 * - anything else (localhost, a preview, a file://) → `null`: a laptop has no
 *   business writing to the project that pages people.
 */
export type SentryEnvironment = 'production';

export function sentryEnvironment(hostname: string): SentryEnvironment | null {
  const host = hostname.toLowerCase().replace(/\.$/, '');
  if (host === 'dev.bolloprint.com' || host.endsWith('.dev.bolloprint.com')) return null;
  if (host === 'bolloprint.com' || host.endsWith('.bolloprint.com')) return 'production';
  return null;
}
